import { useState, useEffect } from 'react'

export default function useMatchMedia(mediaQuery: string) {
  const [media, setMedia] = useState<MediaQueryList>()

  useEffect(() => {
    const matchMedia = window.matchMedia(mediaQuery)
    setMedia(matchMedia)
  }, [mediaQuery])

  return media
}
